import type { Size } from './events';
import type { Vec2 } from './vec2';

export interface Rect {
  x: number;
  y: number;
  width: number;
  height: number;
}

export const Rect = {
  fromPosSize(pos: Vec2, size: Size): Rect {
    return {
      x: pos.x,
      y: pos.y,
      width: size.width,
      height: size.height
    };
  },
  addMargin(rect: Rect, margin: number): Rect {
    return {
      x: rect.x - margin,
      y: rect.y - margin,
      width: rect.width + margin * 2,
      height: rect.height + margin * 2
    };
  },

  contains(rect: Rect, point: Vec2): boolean {
    return (
      point.x >= rect.x &&
      point.x <= rect.x + rect.width &&
      point.y >= rect.y &&
      point.y <= rect.y + rect.height
    );
  },

  containsRect(rect: Rect, other: Rect): boolean {
    return (
      rect.x <= other.x &&
      rect.x + rect.width >= other.x + other.width &&
      rect.y <= other.y &&
      rect.y + rect.height >= other.y + other.height
    );
  },

  intersects(a: Rect, b: Rect): boolean {
    return !(
      a.x + a.width < b.x ||
      a.x > b.x + b.width ||
      a.y + a.height < b.y ||
      a.y > b.y + b.height
    );
  }
};
